import React from "react";

import { useFormContext } from "react-hook-form/dist/react-hook-form.ie11";

import { FranchiseType } from "@hubcapp/types";
import { useTealium } from "@hubcapp/context";

import LessonPreferences from "./LessonPreferences";

const MAX_LEARNER_CAPACITY = 99;

const StateProvider = ({
  disabled,
  loading,
  franchiseType,
  currentTravelTime,
}: {
  disabled: boolean;
  loading: boolean;
  franchiseType?: FranchiseType;
  currentTravelTime: number;
}) => {
  const { watch, setValue, triggerValidation } = useFormContext();
  const { travelTime, learnerCapacity, capLock } = watch([
    "learnerCapacity",
    "travelTime",
    "capLock",
  ]);

  const { trackEvent } = useTealium();

  const handleTravelTimeChange = (_: unknown, value: number | number[]) => {
    setValue("travelTime", value);
  };

  const handleLearnerCapacityChange = (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const updatedMaximumCapacity = parseInt(e.target.value);

    if (updatedMaximumCapacity > MAX_LEARNER_CAPACITY) {
      triggerValidation();
      return;
    }

    trackEvent({
      eventCategory: "Preferences",
      eventAction: "Interaction",
      eventLabel: `${
        franchiseType == FranchiseType.Dit
          ? "DIT Learner Capacity"
          : "Learner Capacity"
      } - ${updatedMaximumCapacity}`,
    });

    setValue("learnerCapacity", {
      ...learnerCapacity,
      maximum: updatedMaximumCapacity,
    });
    triggerValidation();
  };

  const handleTravelTimeClick = () => {
    trackEvent({
      eventCategory: "Preferences",
      eventAction: "Interaction",
      eventLabel: `Travel Time - ${travelTime} Mins`,
    });
  };

  return (
    <LessonPreferences
      disabled={disabled}
      loading={loading}
      travelTime={parseInt(travelTime)}
      onTravelTimeChange={handleTravelTimeChange}
      onLearnerCapacityChange={handleLearnerCapacityChange}
      learnerCapacity={learnerCapacity}
      franchiseType={franchiseType}
      onTravelTimeClick={handleTravelTimeClick}
      capLock={capLock}
      currentTravelTime={currentTravelTime}
    />
  );
};

export default StateProvider;
